export default function responderSolicitudRepresentacionService ({ datosResponderSolicitud, idcorl, token }) {

  return fetch(`${process.env.REACT_APP_API_SISTEMAREPRESENTACIONES}/representaciones/v1/responderSolicitudRepresentacion`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      'HTTP_HEADER_IDCORRELACION': idcorl,
      'HTTP_HEADER_NOMBREAPLICACION': 'HTN.SistemaRepresentaciones.Web',
      'Authorization': token
    },
    body: JSON.stringify(datosResponderSolicitud)
  }).then((response) => {
    return new Promise((resolve) => response.json()
      .then((json) => resolve({
        status: response.status,
        ok: response.ok,
        json,
      })));
  }).then(({ status, json, ok }) => {
    const mjeError = ok? '' : json.status + ': ' +  json.title;   
  
    return { ok: ok, mjeError: mjeError, respuesta: json }        
  })
      
}    
    
    /*
    .then(res => {            
      //Message: "El tipo de representacion que deseas realizar no existe. ¿Te la estas inventando? "
      //StatusCode: 400
      //if (res.status != )
      if (!res.ok) {        
        let err = new Error("HTTP status code: " + res.status)
        err.response = res
        err.status = res.status
        throw err
      }
      return res.json()
    })
   */  
  